<ng-container *ngIf="isInput">
  <label class="d-block">
    <input [type]="item.type"
           (ngModelChange)="onChange($event)"
           [(ngModel)]="value"
           [placeholder]="item.placeholder" class="form-control">
  </label>
</ng-container>

<ng-container *ngIf="isSelect">
  <ng-select [id]="item.key"
             *ngIf="!item.entity"
             [placeholder]="item.placeholder"
             appendTo="body"
             bindLabel="label"
             bindValue="value"
             (ngModelChange)="onChange($event)"
             [(ngModel)]="value"
             [items]="item.options"
             [searchable]="false"
             [hideSelected]="true"
             [clearable]="true">
  </ng-select>

  <form-group-select *ngIf="item.entity"
                     [entity]="item.entity"
                     bindLabel="name"
                     [searchable]="true"
                     [storeQuery]="item.storeQuery"
                     (ngModelChange)="onChange($event)"
                     [(ngModel)]="value"
                     bindValue="id"
                     [placeholder]="item.placeholder"></form-group-select>
</ng-container>

<ng-container *ngIf="isDate">
  <daterange-picker [placeholder]="item.placeholder"
                    [single]="!!item.singleDate"
                    [textValueHidden]="item.pristine"
                    [cancelButton]="true"
                    [tableFilter]="true"
                    (ngModelChange)="onChange($event)"
                    [(ngModel)]="value"
                    [clearable]="false">
  </daterange-picker>
</ng-container>
